import createLucideIcon from '../createLucideIcon';

const ArrowUpCircle = createLucideIcon('ArrowUpCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '16 12 12 8 8 12', key: '1gpmhk' }],
  ['line', { x1: '12', y1: '16', x2: '12', y2: '8', key: 'r2mfdg' }],
]);

export default ArrowUpCircle;
